/**
 * Returns a deterministic index into the games array based on today's date (UTC).
 * All users see the same game on the same calendar day regardless of timezone.
 * Cycles through all games continuously using days-since-epoch.
 */
export function getGameOfTheDayIndex(gameCount, now = new Date()) {
  const epoch = Date.UTC(2025, 0, 1);
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const daysSinceEpoch = Math.floor((today - epoch) / (1000 * 60 * 60 * 24));
  return ((daysSinceEpoch % gameCount) + gameCount) % gameCount;
}
